module.exports = __webpack_public_path__ + "img/tif.a9e514a.svg";